/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaTextareaContent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaTextareaContent({
  children,
  viewPath = "/DesignSystem/TysiaTextarea/TysiaTextareaContent",
  alignItems = "center",
  backgroundColor,
  borderBottomLeftRadius = 4,
  borderBottomRightRadius = 4,
  borderTopLeftRadius = 4,
  borderTopRightRadius = 4,
  borderColor,
  height,
  dock,
  disabled,
  focused,
  invalid,
  autoFocus,
  size,
  hovered,
  valid,
  value,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  placeholder,
  maxLength
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtTysiainputcontentBordercolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.disabled'
        })
let dtTysiainputcontentBordercolorPrimaryFocused = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.focused'
        })
let dtTysiainputcontentBordercolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.invalid'
        })
let borderColorOrdtColorsNeutral300 = borderColor ?? dtColorsNeutral300
let backgroundColorOrdtColorsWhite = backgroundColor ?? dtColorsWhite
  return (<React.Fragment
>
<div
  data-testid="TysiaTextareaContent.Horizontal"
  data-view-path={viewPath}
 style={{'--ai-1-Z1Umvqb': alignItems,'--bc-2-Z1Umvqb': backgroundColorOrdtColorsWhite,'--h-8-Z1Umvqb': typeof height === 'number' ? `${height}px` : height,'--bblr-3-Z1Umvqb': dock === "left" ? "0px" : typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--btlr-5-Z1Umvqb': dock === "left" ? "0px" : typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--bbrr-4-Z1Umvqb': dock === "right" ? "0px" : typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btrr-6-Z1Umvqb': dock === "right" ? "0px" : typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bc-7-Z1Umvqb': disabled ? dtTysiainputcontentBordercolorPrimaryDisabled : focused ? dtTysiainputcontentBordercolorPrimaryFocused : invalid ? dtTysiainputcontentBordercolorPrimaryInvalid : borderColorOrdtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 autoFocus={autoFocus}
 height={height}
 size={size}
 dock={dock}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 value={value}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 placeholder={placeholder}
 maxLength={maxLength}
>
{children}
</Children>
</div>
</React.Fragment>)
}